import { useFlag } from '@unleash/proxy-client-react';

import { useIsLoggedIn } from '@/api/login';
import { useMixedNestingStore } from '@/api/mixedNesting';
import { StarterAside } from '@/blocks/StarterAside';
import { MaterialGroupTabNav } from '@/interfaces/MaterialGroupTabNav';
import { PartTable } from '@/interfaces/PartTable/index';
import { Header, SubHeader } from '@/pages/Order';
import { useCurrentFeatures } from '@/theme';

import { LlmFileImport } from '../../pages/LlmFileImport';

export const StarterParts = () => {
  const { llmFileImport } = useCurrentFeatures();
  const isLoggedIn = useIsLoggedIn();
  const isCustomerExperimentEnabled = useFlag('customer-llm-file-import');
  const partsDisabled = useMixedNestingStore(
    (state) => state.nestingState === 'computing'
  );

  return (
    <div className="content">
      <Header />
      {llmFileImport && isCustomerExperimentEnabled && isLoggedIn && (
        <LlmFileImport />
      )}
      <SubHeader />
      <MaterialGroupTabNav />
      <section className="layout">
        <main>
          <PartTable disabled={partsDisabled} />
        </main>
        <StarterAside />
      </section>
    </div>
  );
};
